/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {deleteTimecardBreakDefinition} from '../api'

export const useMutationDeleteTimecardBreakDefinition = createReactQueryMutationHook('deleteTimecardBreakDefinition', deleteTimecardBreakDefinition)
